"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcNodeNeedsPaging = void 0;
function calcNodeNeedsPaging(node) {
    const ic = node.itemCollection;
    return ic ? ic.items.length < ic.totalCount : false;
}
exports.calcNodeNeedsPaging = calcNodeNeedsPaging;
exports.default = calcNodeNeedsPaging;
